
const isTest = 0//1测试0正式
const testApi = `http://192.168.110.21:9088/rest/v1.1`//测试地址  9086美托美育 9081美托美育 9085斑比之家
// const testApi = `http://8.140.252.239:9088/rest/v1.1`//测试地址  9086美托美育 9081美托美育 9085斑比之家
// const testApi = `http://192.168.1.109:9088/rest/v1.1`//测试地址  9086美托美育 9081美托美育 9085斑比之家
// const onLineApi = `https://www.nicetuoyu.com/yxt/rest/v1.1`//正式地址
const onLineApi = `https://www.17lita.com/yxt/rest/v1.1`//正式地址
const apiV1_1 = isTest == 1 ? testApi : onLineApi
export default apiV1_1